<div style="height: 100%;width:100%;">
  <img #image src="{{imageSource}}" crossorigin>
</div>
